<template>
  <div class="mainPage">
    <div class="guanhuai" @click="changeModule">
      <div class="guanhuai_detail">
        <div class="pic">
          <img src="../../assets/images/origin.png" alt="">
        </div>
        <div style="margin-left:5px">
          普通模式
        </div>
      </div>
    </div>
    <div class="module">
      <div class="title">
        门诊服务
      </div>
      <van-grid :column-num="2">
        <van-grid-item v-for="(item, index) in menuList[0].childList" :key="`frid${index}`" class="gridItem" @click="toPage(item.path,'0')">
          <img slot="icon" :src="item.icon" alt="" class="grid-icon iconfont iconfont-blue" style="width:50%;margin-left:25px">
          <!-- <i class="grid-icon iconfont iconfont-blue" slot="icon" :class="item.icon" /> -->
          <span slot="text" class="grid-text">{{ item.title }}</span>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="module">
      <div class="title">
        住院服务
      </div>
      <van-grid :column-num="2">
        <van-grid-item v-for="(item, index) in menuList[1].childList" :key="`frid${index}`" class="gridItem" @click="toPage(item.path,'1')">
          <img slot="icon" :src="item.icon" alt="" class="grid-icon iconfont iconfont-blue" style="width:50%;margin-left:25px">
          <!-- <i class="grid-icon iconfont iconfont-blue" slot="icon" :class="item.icon" /> -->
          <span slot="text" class="grid-text">{{ item.title }}</span>
        </van-grid-item>
      </van-grid>
    </div>
  </div>

</template>

<script>
export default {
  name: 'OriginModule',
  data() {
    return {
      tabbarActive: '',
      openId: '',
      userInfo: null,

      menuList: [
        {
          name: '门诊',
          childList: [

            {
              title: '门诊缴费',
              icon: require('../../assets/images/payMoney.png'),
              path: '/noFunction'
              // path: '/myPatient?url=menzhenjiaofei'
            },

            {
              title: '报告查询',
              icon: require('../../assets/images/guahao.png'),
              path: '/myPatient?url=baogaolist'
            },
            {
              title: '我的就诊人',
              icon: require('../../assets/images/myPeople.png'),
              // icon: 'icon-jiuzhenren',
              path: '/myPatient'
            },
            // {
            //   title: '预约挂号',
            //   icon: 'icon-yuyueguahao',
            //   path: '/guahaofangshi'
            // },
            // {
            //   title: '我的排队',
            //   icon: 'icon-paiduishu',
            //   path: '/myline'
            // },

            {
              title: '挂号记录',
              icon: require('../../assets/images/guahao.png'),
              // icon: 'icon-guahaojiluchaxun',
              path: '/guahaojilu'
            },
            // {
            //   title: '门诊缴费记录',
            //   icon: 'icon-jiaofeijilu',
            //   path: '/menzhenjiaofeijilu'
            // },
            {
              title: '我的排队',
              icon: require('../../assets/images/myQuery.png'),
              path: '/noFunction'
              // path: 'myPatient?url=myline'
              // path: '/myline'
            },
            {
              title: '门诊缴费记录',
              icon: require('../../assets/images/payMoney.png'),
              path: '/noFunction'
              // path: '/menzhenjiaofeijilu'
            }
            // {
            //   title: '防疫预检登记',
            //   icon: 'icon-yiliao-01',
            //   path: '/yujianfenzhen'
            // }
            // {
            //   title: '患者留言',
            //   icon: 'icon-liuya',
            //   path: '/patientLiuyan'
            // }
          ]
        },
        {
          name: '住院',
          active: 1,
          childList: [

            {
              title: '押金补缴',
              icon: require('../../assets/images/payMoney.png'),
              path: '/yajinbujiao'
            },

            {
              title: '住院报告',
              icon: require('../../assets/images/hospitalList.png'),
              path: '/zhuyuanbaogaorecord'
            },

            {
              title: '住院人信息',
              icon: require('../../assets/images/hospitalInfo.png'),
              path: '/zhuyuan-record'
            },
            {
              title: '补缴记录',
              icon: require('../../assets/images/addRecharg.png'),
              path: '/yajinbujiaorecord'
            },
            {
              title: '住院清单',
              icon: require('../../assets/images/hospitalList.png'),
              path: '/zhuyuanriqingdan'
            }

          ]
        }

      ]
    }
  },
  created() {
    this.userInfo = JSON.parse(localStorage.userInfo || '')
  },
  methods: {
    changeModule() {
      this.$router.push({
        path: '/'
      })
    },
    toPage(url, value) {
      console.log(value)
      if (!url) return
      if (value === '1' && !this.userInfo) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '请先添加就诊人'
          })
          .then(() => {
            this.$router.push(`/addPatient?id=${this.openId}&isNotSelf=1`)
          })
          .catch(() => {
            return false
          })
        return
      }
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.mainPage{
  position: relative;
}
.guanhuai{
  position: fixed;
  right: 1px;
  top: 65%;
  z-index: 666;
  border-radius: 5px;
  .guanhuai_detail{
    width: 38px;
    height: 120px;
    background: #2b8cff;
    border-radius: .08rem 0 0 .08rem;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    vertical-align: center;
    color: #ffffff;
    letter-spacing: 4px;
    .pic{
      width: 30px;
      margin: 0 .1rem .1rem;
      padding-top: 10px;
      img {
        display: block;
        width: .2rem;
        height: auto;
      }
    }
  }
}
.title{
  font-weight: 700;
  font-size: 18px;
  color: rgb(102, 102, 102);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 25px;
  text-decoration: none;
}
.module{
  margin: 0.1rem;
  padding: 0.1rem;
  background: #fff;
  border-radius: 0.1rem;
  overflow: hidden;

}
.img{
  width:60%;
  padding:10px
}
.grid-icon {
  font-size: 80px;
}

.gridItem{
  padding:20px 0;
}

.grid-text {
  margin-top: 10px;
 color: rgb(102, 102, 102);
 font-size:20px;
}

.cell-left-icon {
  font-size: 40px;
  margin-right: 10px;
}

.van-tabbar-item__icon {
  margin-bottom: 0 !important;
  margin-top: 8px;
}

.van-tabbar-item {
  font-size: 18px !important;
}

.van-tabbar {
  height: auto !important;
  padding-top: 10px;
}

.tabbar-title {
  margin: 5px 0 8px;
}

.tabbar-icon {
  font-size: 24px;
}

.notice-swipe {
  height: 40px;
  line-height: 40px;
}

.iconfont-blue {
  color: #1677ff;
}
</style>
